<template>
	<div class="title"><slot></slot></div>
</template>

<style lang="scss" scoped>
.title {
	font-size: 1.9rem;
	font-weight: bold;
	line-height: 1.3;

	&.centered {
		text-align: center;
	}
}

.mt-10vh {
	margin-top: 10vh;
}
.mt-7vh {
	margin-top: 7vh;
}
</style>
